"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = void 0;
const axios_1 = __importDefault(require("axios"));
const store_1 = require("../store/redux/store");
const account_1 = require("../store/redux/account");
const authStorage_1 = require("../services/authStorage");
const handleError = (error) => {
    if (axios_1.default.isAxiosError(error)) {
        if (error.code === "ERR_NETWORK") {
            return {
                error: error.message, status: 500
            };
        }
        const errorResponse = error.response;
        if ([401, 403].includes(errorResponse.status)) {
            store_1.store.dispatch((0, account_1.logoutAction)());
            (0, authStorage_1.clearAuthItems)();
        }
        return {
            error: error.message, detail: errorResponse.data.detail, status: errorResponse.status
        };
    }
    else {
        return { error: String(error) };
    }
};
exports.handleError = handleError;
